import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import {
  SelectContainer,
  SelectLabel,
  SelectStyled,
  SelectedValue,
  OptionsList,
  OptionItem,
  Arrow
} from './SelectField.styled';


const defaultLabelCallback = (option) => option?.label;

const Select = ({ options, placeholder, id, name, value, required, labelCallback = defaultLabelCallback, handleEvent, handleFormData }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(value);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleOptionClick = (option) => {

    setSelectedOption(option?.id);

    handleFormData({ name: id, value: option.id });
    if (typeof handleEvent === 'function') {
      handleEvent();
    }
    setIsOpen(false);
  };


  const selectedLabel = labelCallback(options.find(option => option.id === selectedOption)) || placeholder;

  return (
    <SelectContainer ref={dropdownRef}>
      {placeholder && <SelectLabel htmlFor={id}>{placeholder}</SelectLabel>}
      <SelectStyled onClick={() => setIsOpen(!isOpen)}>
        <SelectedValue>
          {selectedLabel}
          <Arrow $isOpen={isOpen} />
        </SelectedValue>
      </SelectStyled>
      {isOpen && (
        <OptionsList>
          {options.map((option) => (
            <OptionItem key={option.id} onClick={() => handleOptionClick(option)}>
              {labelCallback(option)}
            </OptionItem>
          ))}
        </OptionsList>
      )}
    </SelectContainer>
  );
};

Select.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired
    })
  ).isRequired,
  placeholder: PropTypes.string,
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  required: PropTypes.bool,
  handleEvent: PropTypes.func.isRequired,
  handleFormData: PropTypes.func.isRequired,
  labelCallback: PropTypes.func
};

export default Select;
